/* eslint-disable @typescript-eslint/no-explicit-any */

import dayjs from 'dayjs'

/* eslint-disable no-param-reassign */
export const toThousands = (num: string | number = 0) => {
  return num.toString().replace(/\d+/, (n) => {
    return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  })
}

/**
 *
 * @param str
 * @param isLi 是否是金额厘 需要乘1000
 * @returns
 */
export const fixTableColumnsEmpty = (str: string | number | undefined | null, isLi = false) => {
  if (str || str === 0) {
    return isLi ? Number(str) / 1000 : str
  }
  return '--'
}

/** 获取URL指定参数 */
export function getQueryString(key: string) {
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`)
  const result = window.location.search.slice(1).match(reg)
  return result ? decodeURIComponent(result[2]) : null
}

/** 格式化时间 15s => 00:15 */
export const formatTime = (seconds: number) => {
  let t = '00:00:00'
  if (seconds > -1) {
    const hours = Math.floor(seconds / 3600).toString()
    const minutes = Math.floor(Math.floor(seconds / 60) % 60).toString()
    const sec = Math.floor(seconds % 60).toString()
    t = `${hours === '0' ? '' : `${hours.padStart(2, '0')}:`}${minutes.padStart(2, '0')}:${sec.padStart(2, '0')}`
  }
  return t
}

// 文件下载
export const downloadFile = (url: string, name: string) => {
  return new Promise<void>((resolve, reject) => {
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const downloadUrl = window.URL.createObjectURL(blob)
        const exten = url.slice(Math.max(0, url.lastIndexOf('.') + 1))
        const a = document.createElement('a')
        a.href = downloadUrl
        a.download = `${name}.${exten}`
        document.body.append(a)
        a.click()
        a.remove()
        resolve()
      })
      .catch(() => {
        reject()
      })
  })
}

const toString = Object.prototype.toString

/**
 * @description: 判断值是否未某个类型
 */
export function is(val: unknown, type: string) {
  return toString.call(val) === `[object ${type}]`
}

/**
 * @description:  是否为函数
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function isFunction<T = Function>(val: unknown): val is T {
  return is(val, 'Function')
}

/**
 * @description: 是否已定义
 */
export const isDef = <T = unknown>(val?: T): val is T => {
  return typeof val !== 'undefined'
}

export const isUnDef = <T = unknown>(val?: T): val is T => {
  return !isDef(val)
}
/**
 * @description: 是否为对象
 */
export const isObject = (val: any): val is Record<any, any> => {
  return val !== null && is(val, 'Object')
}

/**
 * @description:  是否为时间
 */
export function isDate(val: unknown): val is Date {
  return is(val, 'Date')
}

/**
 * @description:  是否为数值
 */
export function isNumber(val: unknown): val is number {
  return is(val, 'Number')
}

/**
 * @description:  是否为AsyncFunction
 */
export function isAsyncFunction<T = any>(val: unknown): val is Promise<T> {
  return is(val, 'AsyncFunction')
}

/**
 * @description:  是否为promise
 */
export function isPromise<T = any>(val: unknown): val is Promise<T> {
  return is(val, 'Promise') && isObject(val) && isFunction(val.then) && isFunction(val.catch)
}

/**
 * @description:  是否为字符串
 */
export function isString(val: unknown): val is string {
  return is(val, 'String')
}

/**
 * @description:  是否为boolean类型
 */
export function isBoolean(val: unknown): val is boolean {
  return is(val, 'Boolean')
}

/**
 * @description:  是否为数组
 */
export function isArray(val: any): val is Array<any> {
  return val && Array.isArray(val)
}

/**
 * @description: 是否客户端
 */
export const isClient = () => {
  return typeof window !== 'undefined'
}

/**
 * @description: 是否为浏览器
 */
export const isWindow = (val: any): val is Window => {
  return typeof window !== 'undefined' && is(val, 'Window')
}

export const isElement = (val: unknown): val is Element => {
  return isObject(val) && !!val.tagName
}

export const isServer = typeof window === 'undefined'

// 是否为图片节点
export function isImageDom(o: Element) {
  return o && ['IMAGE', 'IMG'].includes(o.tagName)
}

export function isNull(val: unknown): val is null {
  return val === null
}

export function isNullAndUnDef(val: unknown): val is null | undefined {
  return isUnDef(val) && isNull(val)
}

export function isNullOrUnDef(val: unknown): val is null | undefined {
  return isUnDef(val) || isNull(val)
}

// 验证邮箱
export const validateEmail = (obj: any, value: any) => {
  if (!value) {
    return Promise.resolve()
  }
  const mailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
  if (!mailReg.test(value)) {
    return Promise.reject('邮箱格式不正确，请重新输入')
  }
  return Promise.resolve()
}

export function validatePassword(password: string) {
  // 密码验证正则
  const reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/
  return reg.test(password)
}

export function downloadURL(url: any, name = '', file_extension = 'csv') {
  const link = document.createElement('a')
  link.download = `${name}.${file_extension}`
  link.href = url
  if ('download' in link) {
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } else {
    // 对不支持download进行兼容
    link.target = '_blank'
    click(link)
  }
}

function click(node: any) {
  try {
    node.dispatchEvent(new MouseEvent('click'))
  } catch (e) {
    const evt = document.createEvent('MouseEvents')
    evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null)
    node.dispatchEvent(evt)
  }
}

/** 判断两个数组的值是否相等 */
export const areArraysEqual = (a: any[], b: any[]) => {
  if (a.length !== b.length) {
    return false
  }

  if (a.length === 0 && b.length === 0) {
    return true
  }

  return a.every((el, i) => b[i] === el)
}

export const disabledDate = (current: any) => {
  // 只能选择今天之后的日期,今天不可选~
  // return current && current < dayjs().endOf('day')
  // // 不可以选择之前的日期,今天包括之后可以选，控制大于小于来实现选择之前的日期还是之后的日期
  // return current < dayjs().subtract(1, 'day')
  // // 只能选择今天当天的日期
  // return current > dayjs().subtract(0, 'day') || current < dayjs().subtract(1, 'day')

  // 只能选择当天和当天之后的日期
  return current && current <= dayjs().subtract(1, 'day').endOf('day')
}

/** 判断字符串是否是json */
export function isJSON(str: any) {
  if (typeof str == 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj == 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}

/**
 * @description 数组分段
 * @param arr any[]
 * @param size 分段长度
 *
 * @example
 * const arr = [1,2,3,4,5,6,7];
 * console.log(splitArr(arr, 3));// [ [ 1, 2, 3 ], [ 4, 5, 6 ], [ 7 ] ]
 */
export function splitArr(arr: any[], size = 1) {
  let index = 0
  const res = []
  while (index < arr.length) {
    res.push(arr.slice(index, index + size))
    index += size
  }
  return res
}

/** 校验图片的分辨率 */
export function validImgWidthHeight(file: File) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)

    reader.onload = function () {
      if (reader.readyState == 2) {
        const img = new Image()
        img.src = reader.result as string
        img.onload = function () {
          const h = this?.height >= 20 && this?.height <= 6000
          const w = this?.width >= 20 && this?.width <= 6000
          if (h && w) {
            resolve(true)
          }
          resolve(false)
        }
      }
    }
  })
}
